const LOADING_CLASSNAME = 'blaze-loading';
const SPINNER_TYPE = 'spinner';
const DOTS_TYPE = 'dots';
export { LOADING_CLASSNAME, SPINNER_TYPE, DOTS_TYPE };
//# sourceMappingURL=constants.js.map